/**
 * This file contains all the dependancies library needed
 * 
 * It is used for the library that we don't wish to include in webpack compilation
 */
module.exports = [
    { name: "polyfills",
        type: "js",
        localPath: "libs/polyfills.js"
    },
    { name: "promiseHelper",
        type: "js",
        localPath: "libs/promiseHelper.js"
    },
    {
        name: "pako",
        type: "js",
        version: "x.x.x",
        npmPath: "pako/dist/pako_inflate.min.js"
    },
    { name: "izee-web-view",
        type: "js",
        localPath: "libs/views/WebView.js"
    },
    [
        { name: "izee-web-view-ext-i18n", 
            type: "js",
            localPath: "libs/views/ext/I18next.js"
        },
        { name: "izee-web-view-ext-bootstrap4-dialogs",
            type: "js",
            localPath: "libs/views/ext/Bootstrap4Dialogs.js"
        },
        { name: "izee-web-view-ext-fields",
            type: "js",
            localPath: "libs/views/ext/Fields.js"
        },
        { name: "izee-web-view-ext-charts",
            type: "js",
            localPath: "libs/views/ext/Charts.js"
        },
        { name: "izee-web-view-ext-fields-schema",
            type: "js",
            localPath: "libs/views/ext/FieldsSchema.js"
        },
        { name: "izee-web-view-ext-list", 
            type: "js",
            localPath: "libs/views/ext/List.js"
        },
        { name: "izee-web-view-ext-line-input", 
            type: "js",
            localPath: "libs/views/ext/LineInput.js"
        },
        { name: "izee-web-view-ext-comment-below-above", 
            type: "js",
            localPath: "libs/views/ext/CommentBelowAbove.js"
        },
        { name: "izee-web-view-ext-input-html", 
            type: "js",
            localPath: "libs/views/ext/InputHtml.js"
        },
        { name: "izee-web-view-ext-user-rights",
            type: "js",
            localPath: "libs/views/ext/UserRights.js"
        },
        { name: "izee-web-view-ext-product-line",
            type: "js",
            localPath: "libs/views/ext/ProductLine.js"
        },
        { name: "izee-web-view-ext-business-line",
            type: "js",
            localPath: "libs/views/ext/BusinessLine.js"
        },
        { name: "izee-web-view-ext-partner-alert",
            type: "js",
            localPath: "libs/views/ext/PartnerAlert.js"
        },
        { name: "izee-web-view-ext-pdf-collapse",
            type: "js",
            localPath: "libs/views/ext/PdfCollapse.js"
        },
        { name: "izee-web-view-ext-pdf-preview",
            type: "js",
            localPath: "libs/views/ext/PdfPreview.js"
        },
        { name: "izee-web-view-ext-track-modif",
            type: "js",
            localPath: "libs/views/ext/TrackModif.js"
        },
        { name: "izee-web-view-ext-jsplumb",
            type: "js",
            localPath: "libs/views/ext/JsPlumb.js"
        },
        { name: "izee-web-view-ext-no-form-button",
            type: "js",
            localPath: "libs/views/ext/NoFormButton.js"
        },
        { name: "izee-web-view-ext-fa-icon",
            type: "js",
            localPath: "libs/views/ext/FontAwesomeIcon.js"
        },
        { name: "izee-web-view-ext-upload",
            type: "js",
            localPath: "libs/views/ext/Upload.js"
        },
        { name: "izee-web-view-ext-embed-ctrl",
            type: "js",
            localPath: "libs/views/ext/EmbedController.js"
        },
        { name: "izee-web-view-ext-criteria-fields",
            type: "js",
            localPath: "libs/views/ext/SearchCriteria.js"
        },
        { name: "izee-web-view-ext-custom-fields",
            type: "js",
            localPath: "libs/views/ext/CustomFields.js"
        },
        { name: "izee-web-view-ext-custom-fields-nav",
            type: "js",
            localPath: "libs/views/ext/CustomFieldsNav.js"
        },
        { name: "izee-web-view-ext-custom-fields-nav-search",
            type: "js",
            localPath: "libs/views/ext/CustomFieldsNavSearch.js"
        },
        { name: "izee-web-view-ext-custom-fields-doc",
            type: "js",
            localPath: "libs/views/ext/CustomFieldsDoc.js"
        },
        { name: "izee-web-view-ext-custom-fields-doc-deps",
            type: "js",
            localPath: "libs/views/ext/CustomFieldsDocDeps.js"
        },
        { name: "izee-web-view-ext-mimetype-icon",
            type: "js",
            localPath: "libs/views/ext/MimeIcon.js"
        },
        { name: "izee-web-view-ext-map-link",
            type: "js",
            localPath: "libs/views/ext/MapLink.js"
        },
        { name: "izee-web-view-ext-reusable-text",
            type: "js",
            localPath: "libs/views/ext/ReusableText.js"
        },
        { name: "izee-web-view-ext-company-agency",
            type: "js",
            localPath: "libs/views/ext/CompanyAgencyFields.js"
        },
        { name: "izee-web-view-ext-company-agency-grid",
            type: "js",
            localPath: "libs/views/ext/CompanyAgencyGrid.js"
        },
        { name: "izee-web-view-ext-currency",
            type: "js",
            localPath: "libs/views/ext/CurrencyFields.js"
        },
        { name: "izee-web-view-ext-doc-workflow-user",
            type: "js",
            localPath: "libs/views/ext/DocWorkflowUser.js"
        },
        { name: "izee-web-view-ext-doc-space-type-tag",
            type: "js",
            localPath: "libs/views/ext/DocSpaceTypeTag.js"
        },
        { name: "izee-web-view-ext-reverse-charge",
            type: "js",
            localPath: "libs/views/ext/ReverseChargeField.js"
        },
        { name: "izee-web-view-ext-intracom",
            type: "js",
            localPath: "libs/views/ext/IntracomField.js"
        },
        { name: "izee-web-view-ext-button-templates",
            type: "js",
            localPath: "libs/views/ext/ButtonTemplates.js"
        },
        { name: "izee-web-view-ext-business-allow",
            type: "js",
            localPath: "libs/views/ext/BusinessAllow.js"
        },
        { name: "izee-web-view-ext-second-screen-pdf",
            type: "js",
            localPath: "libs/views/ext/SecondScreenPDF.js"
        },
        
    ],
    [
        { name: "izee-field-reference",
            type: "js",
            localPath: "libs/views/ext/FieldReference.js"
        },
        { name: "izee-field-search-popup",
            type: "js",
            localPath: "libs/views/ext/FieldSearchPopup.js"
        },
	    { name: "izee-field-pdf-page",
            type: "js",
            localPath: "libs/views/ext/FieldPdfPage.js"
        },
        { name: "izee-field-progressbar",
            type: "js",
            localPath: "libs/views/ext/FieldProgressBar.js"
        },
        { name: "izee-field-circularprogressbar",
            type: "js",
            localPath: "libs/views/ext/FieldCircularProgressBar.js"
        },
        { name: "izee-field-mimeicon",
            type: "js",
            localPath: "libs/views/ext/FieldMimeIcon.js"
        },
        { name: "izee-field-suggest",
            type: "js",
            localPath: "libs/views/ext/Suggest.js"
        },
        { name: "izee-field-kanban",
            type: "js",
            localPath: "libs/views/ext/Kanban.js"
        },
        { name: "izee-field-monaco",
            type: "js",
            localPath: "libs/views/ext/MonacoEditor.js"
        },
        { name: "izee-field-tags",
            type: "js",
            localPath: "libs/views/ext/FieldTags.js"
        },
        { name: "izee-field-zipcode",
            type: "js",
            localPath: "libs/views/ext/ZipCodes.js"
        },
        { name: "izee-field-timecost",
            type: "js",
            localPath: "libs/views/ext/TimeCosts.js"
        },
        { name: "izee-field-attach-doc",
            type: "js",
            localPath: "libs/views/ext/AttachDoc.js"
        },
        {
            name: "datePeriodValidation",
            type: "js",
            localPath: "libs/views/ext/DatePeriodValidation.js"
        },
        {
            name: "splitGrid",
            type: "js",
            localPath: "libs/views/ext/SplitGrid.js"
      },
        { name: "izee-field-states-colors",
            type: "js",
            localPath: "libs/views/ext/StatesColors.js"
        },
        { name: "collapseTracker",
            type: "js",
            localPath: "libs/views/ext/CollapseTracker.js"
        },
        { name: "productSubLine",
            type: "js",
            localPath: "libs/views/ext/ProductSubLine.js"
        }
    ],
    [
        { name: "izee-controller",
            type: "js",
            localPath: "libs/controller/AppController.js"
        },
        { name: "izee-controller-view",
            type: "js",
            localPath: "libs/controller/ViewController.js"
        }
    ],
    [
        { name: "izee-controller-grid",
            type: "js",
            localPath: "libs/controller/GridController.js"
        },
        {  name: "izee-controller-form",
            type: "js",
            localPath: "libs/controller/FormController.js"
        },
        {  name: "izee-controller-form-one-record",
            type: "js",
            localPath: "libs/controller/FormOneRecordController.js"
        },
        {  name: "izee-controller-templater", 
            type: "js",
            localPath: "libs/controller/TemplateController.js"
        },
        {  name: "izee-controller-webdav", 
            type: "js",
            localPath: "libs/controller/WebdavController.js"
        }
    ],
    [
        {  name: "izee-controller-importer",
            type: "js",
            localPath: "libs/controller/ImporterController.js"
        }
    ],
    [
        {  name: "izee-controller-kanban",
            type: "js",
            localPath: "libs/controller/KanbanController.js"
        }
    ],
    [
        { name: "izee-controller-grid-and-form",
            type: "js",
            localPath: "libs/controller/GridAndFormController.js"
        }
    ],
    [
        { name: "izee-controller-grid-form-importner",
            type: "js",
            localPath: "libs/controller/GridFormImporterController.js"
        }
    ],
    [
        { name: "izee-controller-table-settings",
            type: "js",
            localPath: "libs/controller/TableSettingsController.js"
        }
    ],
    [
        { name: "izee-controller-grid-form-kanban",
            type: "js",
            localPath: "libs/controller/GridFormKanbanController.js"
        }
    ],
    { name: "izee-service-client", 
        type: "js",
        localPath: "libs/service/ServiceClient.js"
    },
    { name: "izee-usermanagment-client",
        type: "js",
        localPath: "libs/database/UserManagmentClient.js"
    },
    { name: "izee-database-client",
        type: "js",
        localPath: "libs/database/DatabaseClient.js",
    },
    //{ name: "izee-offlinesync-client",
    //    type: "js",
    //    localPath: "libs/database/ext/DbOfflineSync.js"
    //},
    //{ name: "izee-offlinesync-loki",
    //    type: "js",
    //    localPath: "libs/database/ext/DbOfflineLoki.js"
    //},
    
    { name: "izee-crashreport-client",
        type: "js",
        localPath: "libs/database/CrashReportClient.js"
    },
    { name: "izee-binarystorage-client",
        type: "js",
        localPath: "libs/database/BinaryStorageClient.js"
    },
    { name: "izee-data-templates", 
        type: "js",
        localPath: "data/templates.js"
    },
    { name: "izee-data-exports", 
        type: "js",
        localPath: "data/exports.js"
    },
    { name: "izee-data-rights-presets", 
        type: "js",
        localPath: "data/rights_presets.js"
    },

    // [
    //     { name: "izee-binaryoffline-client",
    //         type: "js",
    //         localPath: "libs/database/ext/BinaryOfflineSyncClient.js"
    //     }
    // ],
    // [
    //     {
    //         name: "lie-polyfill", // Promise polyfill for IE (need by localforage)
    //         type: "js",
    //         version: "3.3.0",
    //         cdn: "https://cdnjs.cloudflare.com/ajax/libs/lie/$VERSION/lie.polyfill.min.js",
    //         bowerPath: "lie/dist/lie.polyfill.min.js",
    //         npmPath: "lie/dist/lie.polyfill.min.js"
    //     },
    // ],
    // [
    //     { name: "izee-binaryoffline-forage", //Binary offline in browser
    //         type: "js",
    //         localPath: "libs/database/ext/BinaryOfflineForage.js"
    //     },
    //     {
    //         name: "localforage",
    //         type: "js",
    //         version: "1.7.2",
    //         cdn: "https://cdnjs.cloudflare.com/ajax/libs/localforage/$VERSION/localforage.nopromises.min.js",
    //         bowerPath: "localforage/dist/localforage.nopromises.min.js",
    //         npmPath: "localforage/dist/localforage.nopromises.min.js"
    //     }
    // ],
    // [
    //     { name: "izee-binaryoffline-cordova", //Binary offline in mobile
    //         type: "js",
    //         localPath: "libs/database/ext/BinaryOfflineCordova.js"
    //     }
    // ],

    [ 
        {
            name: "lokijs",
            type: "js",
            version: "1.5.5",
            npmPath: "lokijs/build/lokijs.min.js"
        },
        {
            name: "lokijs-indexed-adapter",
            type: "js",
            version: "1.5.5",
            npmPath: "lokijs/build/loki-indexed-adapter.min.js"
        },
        { name: "moment", //Date manipulation
            type: "js",
            version: "2.22.1",
            npmPath: "moment/min/moment-with-locales.min.js"
        },
        { name: "decimaljs-light", //Number manipulation (operation)
            type: "js",
            version: "2.5.1",
            npmPath: "decimal.js-light/decimal.min.js",
        },
        { name: "custom-protocol-detection", //Custom protocol detector
            type: "js",
            version: "1.0.1",
            npmPath: "custom-protocol-detection/protocolcheck.js",
        },
        { name: "numbro", //number format
            type: "js",
            version: "2.0.6",
            npmPath: "numbro/dist/numbro.min.js"
        },
    ],
    
    [
        { name: "numbro-language",  //number format (langs)
            type: "js",
            version: "2.0.6",
            npmPath: "numbro/dist/languages.min.js"
        },
        { name: "jquery", //bootstrap 4 dep
            type: "js",
            version: "3.3.1",
            npmPath: "jquery/dist/jquery.min.js"
        },
        { name: "popper.js",  //bootstrap 4 dep
            type: "js",
            version: "1.14.3",
            npmPath: "popper.js/dist/umd/popper.min.js"
        }
    ],
    [
        // {name: "bootstrap-css", //bootstrap 4
        //     type: "css",
        //     version: "4.1.1",
        //     npmPath : "bootstrap/dist/css/bootstrap.min.css"
        // },
        {name: "bootstrap-js", //bootstrap 4
            type: "js",
            version: "4.1.1",
            npmPath : "bootstrap/dist/js/bootstrap.min.js"
        },
        {name: "fontawesome", //icons fontawesome
            type: "css",
            version: "5.4.0",
            npmPath : "@fortawesome/fontawesome-free/css/all.css"
        },
        {name: "animate.css", 
            type: "css",
            version: "3.7.0",
            npmPath : "animate.css/animate.min.css"
        },
        {name: "mustache.js", 
            type: "js",
            version: "3.0.0",
            npmPath : "mustache/mustache.min.js"
        },
        {name: "socket.io", 
            type: "js",
            version: "2.2.0",
            npmPath : "socket.io-client/dist/socket.io.js"
        },
        {name: "bootstrap-notify", 
            type: "js",
            version: "3.1.3",
            npmPath : "bootstrap-notify/bootstrap-notify.min.js"
        },
        {name: "handlebars", 
            type: "js",
            version: "4.0.12",
            npmPath : "handlebars/dist/handlebars.min.js"
        },
        {name: "fullcalendar-js", 
            type: "js",
            version: "3.9.0",
            npmPath : "fullcalendar/dist/fullcalendar.min.js"
        },
        {name: "fullcalendar-css", 
            type: "css",
            version: "3.9.0",
            npmPath : "fullcalendar/dist/fullcalendar.min.css"
        }
    ],
    [
        {name: "fullcalendar-locale-fr", 
            type: "js",
            version: "3.9.0",
            npmPath : "fullcalendar/dist/locale/fr.js"
        },
        {name: "fonts",
            type: "css",
            version: "1.0.0",
            localPath: "views/global/fonts.css",
        },
        {name : "xlsx", //import XLS files 
            type: "js",
            version: "0.13.2",
            npmPath : "xlsx/dist/xlsx.full.min.js"
        },
        {name : "qrious.js", //qrcode 
            type: "js",
            version: "4.0.2",
            npmPath : "qrious/dist/qrious.js"
        },
        {name: "split-grid", //successor of Split.js, built for CSS Grid
            type: "js",
            version: "1.0.11",
            npmPath : "split-grid/dist/split-grid.min.js"
        }
    ]
] ;
